import apiFetch from '../apiFetch'

export default function (token, documentsIds, documentName, organizedUnitId, dossierId) {
  return apiFetch({ endPoint: `Document/${organizedUnitId}/${dossierId}/Group`, method: 'POST', body: { documentsIds: documentsIds, documentName: documentName }, token: token })
}
